import { Order, OrderStatus, SaleItem } from '@src/core/buyerApiClient';
import { LayoutColors } from '@src/core/theme';
import { ReturnedValueType } from './sale';

export const getConvertedOrderStatusType = (status: OrderStatus): ReturnedValueType => {
  switch (status) {
    case OrderStatus.Created:
      return { type: 'info', background: LayoutColors.justBlue };
    case OrderStatus.Expired:
      return { type: 'warning', background: LayoutColors.warningDark };
    case OrderStatus.Confirmed:
      return { type: 'success', background: LayoutColors.successDark };
    case OrderStatus.PaymentVoided:
    case OrderStatus.PaymentChargedBack:
      return { type: 'danger', background: LayoutColors.errorMain };
  }
};

export const orderSaleItems = (order: Order) =>
  order.sales.reduce((arr, sale) => [...arr, ...sale.items], [] as SaleItem[]);

export const getOrderAnalyticsData = (order: Order) => {
  const items = [];
  for (const sale of order.sales) {
    items.push(
      ...sale.items.map((item) => ({
        item_id: item.product.id,
        item_name: item.product.name,
      })),
    );
  }

  return {
    orderId: order.id,
    items,
    itemsCount: items.length,
    value: order.finalAmountCents / 100,
    paymentMethod: order.lastTransaction?.paymentMethod.code,
  };
};
